export enum ScheduledAnnouncementTypes {
  ReleaseNotes = 1,
  InAppAlerts = 2
}

export enum ScheduledAnnouncementAudiences {
  Internal = 1,
  Applicant = 2,
  ClientUser = 3,
  ApplicantAndClientUser = 4
}

interface ScheduledAnnouncement {
  id: number;
  startDate: string;
  endDate: string;
  announcementType: ScheduledAnnouncementTypes;
}

export interface ReleaseNoteFromApi extends ScheduledAnnouncement {
  releaseNumber: string;
  releaseNotesUrl: string;
  announcementDate: string;
}

export interface InAppAlertFromApi extends ScheduledAnnouncement {
  title: string;
  body: string;
  announcementAudience: ScheduledAnnouncementAudiences;
}
